import { useState }    from 'react';
import useLocalStorage from '../hooks/use_local_storage';


export default function useCompleted(key, initialState) {
  const [ isCompleted, setIsCompleted ] = useLocalStorage(key, initialState);
  const [ isCollapsed, setIsCollapsed ] = useState(isCompleted);

  function expand() {
    if (isCollapsed)
      setIsCollapsed(false);
  }

  function complete() {
    setIsCompleted(true);
    setIsCollapsed(true);
  }

  return {
    isCompleted,
    isCollapsed,
    expand,
    complete
  };

}
